module.exports = __webpack_public_path__ + "static/media/pixelmixer_promo.b34a79a7.gif";